<template>
  <div>
    <!-- <vue-element-loading :active="appLoading" :is-full-screen="false" /> -->
    <v-snackbar v-model="showsnackbar" color="primary" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12 md12 pa-0>
        <v-card id="app_height" outlined tile>
          <v-layout wrap justify-space-around>
            <v-flex xs12 md12 pa-8>
              <v-layout pb-2 wrap justify-center>
                <v-flex xs12 md12 text-center>
                  <span style="font-size:20px;font-weight:500;">Edit Team Member</span>
                </v-flex>
              </v-layout>
              <v-container>
                <v-row no-gutters>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      ref="MemberName"
                      v-model="MemberName"
                      prepend-icon="mdi-account"
                      label="Team Member Name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      ref="MemberRole"
                      v-model="MemberRole"
                      prepend-icon="mdi-keyboard"
                      label="Team Member Role"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      ref="Qualification"
                      v-model="Qualification"
                      prepend-icon="mdi-note"
                      label="Qualification"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      ref="Specialization"
                      v-model="Specialization"
                      prepend-icon="mdi-note"
                      label="Specialization"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      ref="Experience"
                      v-model="Experience"
                      prepend-icon="mdi-clock-fast"
                      label="Experience"
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="6" py-2>
                    <v-file-input label="File input" dense prepend-icon="mdi-camera"></v-file-input>
                  </v-col>-->

                  <v-col cols="12" sm="12" lg="12">
                    <label></label>
                    <v-layout pt-5 wrap justify-center>
                      <v-flex text-center>
                        <span style="font-size:18px;font-weight:400">Add Image</span>
                        <p style="font-size:12px">Hint: Image size should be maximum 5mb</p>
                      </v-flex>
                    </v-layout>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="profilepic != ''">
                    <v-layout wrap justify-center>
                      <v-flex xs12 sm12 md12>
                        <img
                          v-bind:src="baseURL+'/document/get/'+profilepic"
                          height="auto"
                          width="20%"
                        />
                      </v-flex>
                    </v-layout>
                  </v-col>
                  <v-col cols="12" sm="6" lg="12">
                    <v-layout wrap justify-center>
                      <v-flex text-center pb-4>
                        <input
                          id="pic"
                          ref="uploadPicture"
                          accept="image/*"
                          type="file"
                          @change="uploadPicture"
                        />
                      </v-flex>
                    </v-layout>
                  </v-col>

                  <v-col cols="12" sm="12" lg="12">
                    <label>Description</label>
                    <vue-editor
                      v-model="description"
                      ref="description"
                      prepend-icon="mdi-format-align-justify"
                      label="Description"
                      color="#26af82"
                    ></vue-editor>
                  </v-col>
                </v-row>

                <v-row py-4>
                  <v-col cols="12" sm="6" lg="12">
                    <v-flex text-center>
                      <v-btn
                        @click="handleSubmit"
                        rounded
                        small
                        dark
                        :ripple="false"
                        class="text-capitalize"
                        color="primary"
                        width="250"
                      >UpdateTeam Member</v-btn>
                    </v-flex>
                  </v-col>
                </v-row>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

import { VueEditor } from "vue2-editor";
export default {
  props: ["id"],
  components: {
    VueEditor
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      msg: null,
      timeout: 10000,
      MemberName: "",
      MemberRole: "",
      Qualification: "",
      Specialization: "",
      Experience: "",
      description: "",
      profilepic: ""
    };
  },

  beforeMount() {
    this.loadData();
  },

  methods: {
    uploadPicture(event) {
      this.picture = event.target.files[0];
      //   if (event.target.files[0].size > 5242880) {
      //     this.msg = "File Should be less than 5MB";
      //     this.showsnackbar = true;
      //     return;
      //   }
      this.url = URL.createObjectURL(this.picture);
    },

    loadData: function() {
      var vm = this;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/team/view/" + this.id,
        headers: {
          token: localStorage.getItem("token")
        }
      })
        .then(response => {
          vm.appLoading = false;
          if (response.data.status) {
            var data = response.data.data;
            vm.MemberName = data.name;
            vm.MemberRole = data.position;
            vm.Qualification = data.qualification;
            vm.Specialization = data.expertise;
            vm.Experience = data.experience;
            vm.description = data.description;
            if (data.photo != undefined) {
              this.profilepic = data.photo;
            }
          } else {
            vm.msg = response.data.msg;
            vm.showsnackbar = true;
          }
        })
        .catch(err => {
          vm.appLoading = false;
          vm.ms = err.response;
          vm.msg = "Server Unreachable";
          vm.showsnackbar = true;
        });
    },
    handleSubmit: function() {
      this.appLoading = true;
      var data = {};
       data["name"] = this.MemberName;
      data["position"] = this.MemberRole;
      data["description"] = this.description;
      data["qualification"] = this.Qualification;
      data["expertise"] = this.Specialization;
      data["experience"] = this.Experience;

      if (this.id != "") {
        data["id"] = this.id;
      }
      axios({
        method: "POST",
        url: "/team/edit/" + this.id,
        headers: {
          token: localStorage.getItem("token")
        },
        data: data
      })
        .then(response => {
          if (response.data.status) {
            this.appLoading = false;
            this.submitPicture(this.id);
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.$router.push("/Team");
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.$router.push("/Team");
          }
        })

        .catch(err => {
          this.appLoading = false;
          this.ms = err.response;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    submitPicture: function(tid) {
      let formData = new FormData();
      formData.append("photo", this.picture);

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/team/upload/photo/" + tid,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token")
        },
        data: formData
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
              this.loadData();
            // this.msg = response.data.msg;
            // this.showsnackbar = false;
          } 
        })
        .catch(err => {
          this.appLoading = false;
          this.ms = err.response;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    }
  }
};
</script>
<style>
.v-input {
  padding-left: 10px;
  padding-right: 10px;
}
</style>